import * as React from "react";

const SadColorIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill="#EF4444"
      d="M8.5 1.5A6.5 6.5 0 1 0 15 8a6.507 6.507 0 0 0-6.5-6.5ZM6.25 6a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm5 5.432a.5.5 0 0 1-.682-.182C10.1 10.443 9.367 10 8.5 10s-1.6.444-2.067 1.25a.5.5 0 1 1-.865-.5C6.21 9.638 7.279 9 8.5 9c1.22 0 2.29.637 2.933 1.75a.5.5 0 0 1-.183.682Zm-.5-3.932a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    />
  </svg>
);
export default SadColorIcon;
